import React from 'react';

import { Box, IconButton, Typography } from '@mui/material';
import Modal from 'components/ModalV2';
import PropTypes from 'prop-types';
import ProdSetup from 'views/V2/SandboxSetupGuide/environments/ProdSetup';

import styles from './setupGuideModal.module.css';

import { ReactComponent as CloseIcon } from 'asset/IconsPack/at_x-close.svg';

function SetupGuideModal({ open, onClose }) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            className={styles.setupGuideModal}
            fullScreen
            disableBackdropClick
        >
            <Box className={styles.modalInnerContainer}>
                <Box className={styles.modalHeader}>
                    <Typography className={styles.modalHeaderTitle}>Setup Guide</Typography>
                    <IconButton onClick={onClose} className={styles.modalHeaderCloseBtn}>
                        <CloseIcon className={styles.modalHeaderCloseIcon} />
                    </IconButton>
                </Box>
                <Box className={styles.modalContent}>
                    <ProdSetup isModal />
                </Box>
            </Box>
        </Modal>
    );
}

SetupGuideModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
};

export default SetupGuideModal;
